import React from 'react';

export const Stack = ({ 
  children, 
  spacing = 4,
  direction = 'vertical',
  className = '' 
}) => {
  const spacingClass = direction === 'vertical' ? `space-y-${spacing}` : `space-x-${spacing}`;
  const flexDirection = direction === 'vertical' ? 'flex-col' : 'flex-row';
  
  return (
    <div className={`flex ${flexDirection} ${spacingClass} ${className}`}>
      {children}
    </div>
  );
};
